import React, { useEffect, useState } from 'react';
import Card from '../../componentes/contenedores/Card';
import Page from '../../componentes/plantilla/Page';
import { Link } from "react-router-dom";
import ListaPerfiles from '../../componentes/contenedores/ListaPerfiles';
import { EmpleadoFiltro, EmpleadoId, EmpleadosListar } from '../../configuracion/apiUrls';
import { useContextEmpleado } from '../../contexto/empleado/EmpleadoContext';

const HomeEmpleados = () => {
  const { listaEmpleados, setListaEmpleados, ActualizarLista } = useContextEmpleado();
  const [idEmpleado, setIdEmpleado] = useState('');
  const [errorIdEmpleado, setErrorIdEmpleado] = useState(false);
  const [filtro, setFiltro] = useState('');
  const [errorFiltroEmpleado, setErrorFiltroEmpleado] = useState(false);
  //console.log(listaEmpleados);
  const datos = {
    titulo: {
      titulo: "Edicion de empleados",
      url: "/app/admin/empleados/gestionar",
      tituloUrl: "empleados",
      nombreUrl: "Nuevo"
    }
  }

  useEffect(() => {
              if (!Array.isArray(listaEmpleados) || listaEmpleados.length === 0) {
                  ActualizarLista(EmpleadosListar, setListaEmpleados);
              }
          }, [ActualizarLista, listaEmpleados, setListaEmpleados]);
  

  useEffect(() => {
    const regexEntero = /^\d+$/;
    if (idEmpleado.length > 0) {
      if (regexEntero.test(idEmpleado)) {
        ActualizarLista(EmpleadoId + idEmpleado, setListaEmpleados);
        setErrorIdEmpleado(false)
      } else {
        setErrorIdEmpleado(true);
      }
    }
    else {
      ActualizarLista(EmpleadosListar, setListaEmpleados);
      setErrorIdEmpleado(false)
    }
  }, [idEmpleado])

  useEffect(() => {
    if (filtro.length > 2) {
      ActualizarLista(EmpleadoFiltro + filtro, setListaEmpleados);
      setErrorFiltroEmpleado(false)
    }
    else {
      ActualizarLista(EmpleadosListar, setListaEmpleados);
      setErrorFiltroEmpleado(true)
    }
  }, [filtro])

  return (
    <Page datos={datos}>
      <div className='row'>
        <div className='col-12'>
          <Card
            titulo="Empleados"
            pie={
              <Link to={"/app/admin/empleados/nuevo"}>
                <button className="btn btn-info d-flex align-items-center gap-2 px-3 py-2 fw-bold shadow-sm rounded">
                  <i className="fas fa-user-plus mx-2"></i>
                  <span>Nuevo Empleado</span>
                </button>
              </Link>
            }
          >
            {/* Informacion general y creacion */}
            <div>
              <h6 className="card-title">Modulo de gestión de empleados</h6>
              <p className="card-text">
                Este módulo está diseñado para ayudar en la administración de manera efectiva la información y los procesos relacionados con sus empleados.
              </p>
            </div>
          </Card>
        </div>
      </div>
      <Card titulo="Lista de empleados">
        <div className='row'>
          <div className="col-sm-12 col-lg-4">
            <div className="form-group">
              <label htmlFor="exampleInputEmail1">Id</label>
              <input
                type="text"
                className={`form-control ${errorIdEmpleado ? "is-invalid" : ""}`}
                id="text"
                placeholder="Id del empleado"
                name="id"
                value={idEmpleado}
                onChange={e => setIdEmpleado(e.target.value)}
              />
            </div>
          </div>
          <div className="col-sm-12 col-lg-8">
            <div className="form-group">
              <label htmlFor="exampleInputEmail1">Filtro</label>
              <input
                type="text"
                className={`form-control`}
                id="text"
                placeholder="Escriba el nombre o apellido"
                name="filtro"
                value={filtro}
                onChange={e => setFiltro(e.target.value)}
              />
            </div>
          </div>
        </div>
        <ListaPerfiles lista={listaEmpleados} />
      </Card>
    </Page>
  )
}

export default HomeEmpleados;